import React, {useState} from 'react';
import '../styles/header.css';
import $ from 'jquery';
import {Grid} from "@nextui-org/react";

function AppHeader() {
    const [currentPage, setCurrentPage] = useState('front');

    function changePage(pageDirection: string) {
        let elem = $('.cube');
        let header = $('header');
        let wrapper = $('#wrap');

        elem.removeClass('reverse-' + currentPage);
        elem.addClass('reverse-' + pageDirection);

        header.addClass('go-out');
        wrapper.addClass('active');

        $('.link-' + currentPage).removeClass('active');
        $('.link-' + pageDirection).addClass('active');

        setTimeout(function () {
            header.removeClass('go-out');
            wrapper.removeClass('active');
        }, 1000);

        setCurrentPage(pageDirection);
    }

    return (
        <header>
            <nav id={'head'}>
                <div className={"inline-block"}>
                    <a id={"headTitle"} href={"/"}>Chirag Gupta</a>
                </div>
                <Grid.Container gap={2} id={"navigations"} className={'quickLinks'}>
                    <Grid className={'links link-front active'} onClick={() => changePage('front')}>
                        <a href="#">Work</a>
                    </Grid>
                    <Grid className={'links link-back'} onClick={() => changePage('back')}>
                        <a href="#">About</a>
                    </Grid>
                </Grid.Container>
            </nav>
        </header>
    );
}

export default AppHeader;
